module.exports = __webpack_public_path__ + "static/media/home_img3.d4891133.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_img3.png
// module id = 393
// module chunks = 14